import EditIcon from "components/Icons/EditIcon";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import DeleteIcon from "components/Icons/DeleteIcon";
import { useFaqAlertContext } from "./AlertContext";
import { IFaq } from "models/faq";

interface IProps {
  faq: IFaq;
}

export default function Action({ faq }: IProps) {
  const { showDelete } = useFaqAlertContext();

  const handleDelete = () => showDelete(faq);

  return (
    <div className="flex items-center gap-x-3">
      <Link
        to={RouteName.EDIT_FAQ.replace(":id", faq.id)}
        className="rounded-ful hover:text-black"
      >
        <EditIcon />
      </Link>
      <button onClick={handleDelete} className="rounded-ful">
        <DeleteIcon />
      </button>
    </div>
  );
}
